var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./OrganizationApiChannelTemplateAddForm.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5df19986\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OrganizationApiChannelTemplateAddForm.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/profile/OrganizationApiChannelTemplateAddForm.vue
// module id = 1464
// module chunks = 4